// THIS FILE WAS AUTOGENERATED
"use strict";
    
    /**
     * Type of the metric data measurement.
     */
    enum DataPointType
    {
        Measurement = 0,
        Aggregation = 1,
    }
export = DataPointType;
